import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment, Popover2} from '@api'
import {ChangeLogEntriesForCatalogItemAtTimestampStore, useChangeLogEntriesForCatalogItemAtTimestampStore} from '.'
import {BuilderCard, BuilderCardLoader, BuilderCardWithPopover, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogFieldConfig, StoresInstance, Workspace} from '@stores'
import * as css from './ChangeEntryCatalogItem.css'

/// region Store

export class ChangeEntryCatalogItemStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { changeEvent: ChangeLogEntriesForCatalogItemAtTimestampStore}) {
    super(stores)
  }

  get changeEvent() { return this.props.changeEvent}
  get root() { return this.changeEvent.root}

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @action onClick = () => {
    // const {root: {onClickItemOpenInDetailsPane_old}, firstItem, workspace} = this
    // return onClickItemOpenInDetailsPane_old(firstItem, workspace)

    const {root, workspace, fieldValue, changeEvent} = this
    if (root.popoverItem?.data != fieldValue) {
      root.popoverItem = { data: fieldValue, workspace, changeEvent}
    }
    else {
      root.popoverItem = null
    }
  }

  get field() { return this.props.field }
  @computed get workspace() : Workspace {
    const {field, changeEvent} = this
    if (!field) return changeEvent.workspace

    return this.workspaces.workspaceForIndex(field.esIndex) ?? changeEvent.workspace
  }

  @computed get fieldValue() {
    const {changeEvent: { firstItem }, field} = this
    return field ? _.get(firstItem, field.field) : firstItem
  }

  @computed get label() {
    const {fieldValue, workspace: {dataMap}} = this
    return _.get(fieldValue, dataMap.title)
  }
}

export const ChangeEntryCatalogItemStoreContext = React.createContext<ChangeEntryCatalogItemStore>(null)
export const useChangeEntryCatalogItemStore = () => React.useContext(ChangeEntryCatalogItemStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  field?: ICatalogFieldConfig
}

export const ChangeEntryCatalogItem = observer<MyProps>(function ChangeEntryCatalogItem({className, ...props}) {
  const changeEvent = useChangeLogEntriesForCatalogItemAtTimestampStore(),
  obsProps = useAsObservableSource({...props, changeEvent}),
    store = useVipLocalStore((stores) => new ChangeEntryCatalogItemStore(stores, obsProps)),
    {onClick, label, changeEvent: {id}, workspace, fieldValue} = store

  useEffect(() => store.registerEffects(), [])

  // console.log({workspace: workspace._id, fieldValue})
  return (
    <ChangeEntryCatalogItemStoreContext.Provider value={store}>
      <Popover2
        interactionKind='click'
        placement='bottom'
        // isOpen={popoverItem?.changeEvent == store}
        // onInteraction={onPopoverInteraction}
        minimal={false}
        content={
          <BuilderCard
		                  data={fieldValue}
		                  showImage
		                  isPopover
		                  workspace={workspace.config}
		                  visibleCardFields={workspace.defaultVisibleCardFields}
	                  />}
        >
      <div
          className={classNames(css.root, className)}
          data-id={id}
          data-workspace={workspace.id}
          data-type={'item-name-url'}
          // onClick={onClick}
        >
          {label}
        </div>
    </Popover2>
    </ChangeEntryCatalogItemStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/entries/ChangeEntryCatalogItem.tsx